module.exports = __webpack_public_path__ + "img/ic_help_outline-16px.3f36b005.png";